/**
 *
 * @author Jesus R. Nava Cruz
 * @date May 24, 2023
 * @version 1.0
 *
 */

export default {
  path: "/app/config/logs",
  name: "LOGS",
  component: () => import("@/app/views/crud/CrudSimpleView.vue"),
  meta: {
    service: () => import("@/app/services/LogService"),
    table: () => import("@/app/components/config/logs/LogTable.vue"),
    form: () => import("@/app/components/config/logs/LogForm.vue"),
    header: {
      icono: "mdi-console-line",
      texto: "Logs",
      textNew: "Registrar Log",
      textEdit: "Modificar Log",
    },
    prm: "ND",
    requireAuth: true,
    hideButtonAdd: true
  },
};
